<template>
    <modal id="create-tooltip-modal"
            title="Create new tooltip"
            :visible="show"
            ok-title="Proceed"
            :ok-disabled="!tooltipState"
            @ok="createTooltip"
            @hide="clearInput"
            class="lx-global-modal"
            >
        <b-container fluid>
            <b-row class="my-1">
                <b-col sm="2">
                    <label for="input-text">Text:</label>
                </b-col>
                <b-col sm="10">
                    <b-form-input 
                        id="input-text"
                        v-model="text"
                        :state="tooltipTextState"
                        placeholder="Enter tooltip (span) text"
                        aria-describedby="input-live-help input-live-feedback"
                    />
                </b-col>
                <b-col sm="2">
                    <label for="input-hover-text">Hover:</label>
                </b-col>
                <b-col sm="10">
                    <b-form-input 
                        id="input-hover-text"
                        v-model="hoverText"
                        :state="tooltipHoverTextState"
                        placeholder="Enter text that will appear on hover"
                        aria-describedby="input-live-help input-live-feedback"
                    />
                </b-col>
                <b-col sm="2">
                    <label for="input-hover-text">Partner:</label>
                </b-col>
                <b-col sm="10">
                    <b-form-select 
                        id="select-partner"
                        v-model="partner"
                        :options="options"
                        :state="tooltipPartnerSelectState"
                        aria-describedby="input-live-help input-live-feedback"
                    />
                </b-col>
            </b-row>
        </b-container>
    </modal>
</template>

<script>
    import { mapGetters } from 'vuex';
    import Modal from '../../../generic/modal/modal.vue';
    import API from '../../../.././api';
    
    export default {
        name: 'CreateTooltipModal',
        components: {
            Modal
        },        
        props: {
            show: {
                type: Boolean,
                default: false,
            },
            options: {
                type: Array,
                default: () => []
            }
        },
        computed: {
            ...mapGetters('partner', ['partnerIds', 'partnerTitleById']),
            tooltipTextState() {
                return this.text.length > 0 ? true : false;
            },
            tooltipHoverTextState() {
                return this.hoverText.length > 0 ? true : false;
            },
            tooltipPartnerSelectState() {
                if (this.partner != null && this.partner != undefined) {
                    return true;
                }
                return false;
            },
            tooltipState() {
                if (this.tooltipTextState && this.tooltipHoverTextState && this.tooltipPartnerSelectState) {
                    return true;
                }
                return false;
            },
        },
        data() {
            return {
                text: '',
                hoverText: '',
                partner: null,
            }
        },
        methods: {
            clearInput() {
                this.text = '';
                this.hoverText = '';
                this.partner = null;
            },
            async createTooltip() {
                try {
                    this.$emit('startCreating');
                    await API.post(
                        `/app/partner-cards/tooltip/`,
                        {
                            text: this.text,
                            hover_text: this.hoverText,
                            partner: this.partner,
                        }
                    );
                    const message = 'Tooltip has been created';
                    this.successToast({text: message})
                }
                catch (error) {
                    this.errorToast({text: 'Could not create a tooltip.'})
                }
                this.$emit('endCreating');
                this.clearInput();
            }
        }
    }
</script>


<style lang="scss" scoped>
:deep(.container-fluid) {
    padding-left: 0px !important;
}

:deep(label) {
    margin-top: 0.4rem;
}

:deep(.col-sm-10) {
    padding-bottom: 16px;
}

:deep(.btn-primary.disabled),
:deep(.btn-primary:disabled) {
    cursor: not-allowed;
}

</style>